export default "__VITE_ASSET__CT$Y5q8I__"